/*
 *   File : add-corridor-modal.js
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations : 
 *   Version : 1.0.0
*/
import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import jsonlint from "jsonlint-mod";
import { useNavigate } from 'react-router-dom';

import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextArea, CustomTextInput, BasicFilter } from '../FormElements';
import { APIService } from '../../Service';

const AddCorridorModal = ({ handleClose, onSuccess }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [countryName, setCountryName] = useState("");
    const [countryNameError, setCountryNameError] = useState("");
    const [destinationCountry, setDestinationCountry] = useState("");
    const [destinationCountryError, setDestinationCountryError] = useState("");
    const [beneficiaryCurrency, setBeneficiaryCurrency] = useState("");
    const [beneficiaryCurrencyError, setBeneficiaryCurrencyError] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [paymentTypeError, setPaymentTypeError] = useState("");
    const [channelBank, setChannelBank] = useState("");
    const [channelBankError, setChannelBankError] = useState("");
    const [destinationService, setDestinationService] = useState("");
    const [destinationServiceError, setDestinationServiceError] = useState("");
    const [channelCash, setChannelCash] = useState("");
    const [destinationServiceCash, setDestinationServiceCash] = useState("");
    const [channelWallet, setChannelWallet] = useState("");
    const [destinationServiceWallet, setDestinationServiceWallet] = useState("");

    const [accountPrefix, setAccountPrefix] = useState("");
    const [accountPrefixError, setAccountPrefixError] = useState("");
    const [accountPrefix1, setAccountPrefix1] = useState("");
    const [accountPrefix2, setAccountPrefix2] = useState("");
    const [regex, setRegex] = useState("");
    const [regexError, setRegexError] = useState("");
    const [regex1, setRegex1] = useState("");
    const [regex1Error, setRegex1Error] = useState("");
    const [regex2, setRegex2] = useState("");
    const [regex2Error, setRegex2Error] = useState("");
    const [countryLoading, setCountryLoading] = useState(true);
    const [countryOptions, setCountryOptions] = useState([]);

    useEffect(() => {
        const modalEl = document.getElementById("add-corridor-modal");
        if (modalEl) {
            modalEl.addEventListener("hidden.bs.modal", () => {
                handleClose();
            });
        }
    }, []);

    useEffect(() => {
        _getCountryList();
    }, []);

    useEffect(() => {
        setCountryNameError("");
    }, [countryName]);

    useEffect(() => {
        setDestinationCountryError("");
    }, [destinationCountry]);

    useEffect(() => {
        setPaymentTypeError("");
    }, [paymentType]);

    useEffect(() => {
        setBeneficiaryCurrencyError("");
    }, [beneficiaryCurrency]);

    useEffect(() => {
        setChannelBankError("");
    }, [channelBank]);

    useEffect(() => {
        setDestinationServiceError("");
    }, [destinationService]);

    useEffect(() => {
        setAccountPrefixError("");
    }, [accountPrefix]);

    useEffect(() => {
        setRegexError("");
    }, [regex]);

    useEffect(() => {
        setRegex2Error("");
    }, [regex2]);

    useEffect(() => {
        setRegex2Error("");
    }, [regex2]);

    // API - Get country list
    const _getCountryList = () => {
        const is_post = false;
        const url = 'general/countries';

        APIService(is_post, url, {}).then((response) => {
            if (response.status_code === 200) {
                // Transform API response to BasicFilter format
                const options = response.data.map((country) => ({
                    value: country.name,
                    label: country.name,
                    country_code: country.country_code,
                    currency_code_with_precision: country.currency_code_with_precision,
                }));
                setCountryOptions(options);
            }
            setCountryLoading(false);
        });
    };


    //handle add corridor
    // const _handleCreate = () => {
    //     let is_valid = true;

    //     // Basic input validations
    //     if (countryName.trim().length === 0) {
    //         setCountryNameError("Country name is required");
    //         is_valid = false;
    //     }
    //     if (destinationCountry.trim().length === 0) {
    //         setDestinationCountryError("Password is required");
    //         is_valid = false;
    //     }
    //     if (beneficiaryCurrency.trim().length === 0) {
    //         setBeneficiaryCurrencyError("Beneficiary currency and decimal precision is required");
    //         is_valid = false;
    //     }
    //     if (paymentType.trim().length === 0) {
    //         setPaymentTypeError("Payment type is required");
    //         is_valid = false;
    //     }
    //     if (channelBank.trim().length === 0) {
    //         setChannelBankError("Channel type is required");
    //         is_valid = false;
    //     }
    //     if (destinationService.trim().length === 0) {
    //         setDestinationServiceError("Destination service tag is required");
    //         is_valid = false;
    //     }
    //     if (accountPrefix.trim().length === 0) {
    //         setAccountPrefixError("Account URA prefixes is required");
    //         is_valid = false;
    //     }
    //     //---------------------------------
    //     // JSON VALIDATION FUNCTION
    //     //---------------------------------
    //     const validateJson = (value, setError) => {
    //         if (value.trim().length === 0) {
    //             setError("JSON input is required");
    //             return false;
    //         }

    //         try {
    //             jsonlint.parse(value);
    //         } catch (e) {
    //             setError(`Syntax error: ${e.message}`);
    //             return false;
    //         }

    //         try {
    //             JSON.parse(value);
    //         } catch {
    //             setError("Invalid JSON object");
    //             return false;
    //         }

    //         return true;
    //     };

    //     //---------------------------------
    //     // REGEX1 (Mandatory)
    //     //---------------------------------
    //     setRegexError("");
    //     const validRegex1 = validateJson(regex, setRegexError);
    //     if (!validRegex1) return;

    //     //---------------------------------
    //     // REGEX2 (Optional)
    //     //---------------------------------
    //     setRegex1Error("");
    //     if (regex1.trim().length > 0) {
    //         const validRegex2 = validateJson(regex1, setRegex1Error);
    //         if (!validRegex2) return;
    //     }

    //     //---------------------------------
    //     // REGEX3 (Optional)
    //     //---------------------------------
    //     setRegex2Error("");
    //     if (regex2.trim().length > 0) {
    //         const validRegex3 = validateJson(regex2, setRegex2Error);
    //         if (!validRegex3) return;
    //     }

    //     //---------------------------------
    //     // SUBMIT
    //     //---------------------------------
    //     if (is_valid) {
    //         // setCountryName("");
    //         // setPaymentType("");
    //         // setBeneficiaryCurrency("");
    //         // setDestinationCountry("");
    //         // setChannelBank("");
    //         // setDestinationService("");
    //         // setChannelCash("");
    //         // setChannelWallet("");
    //         // setDestinationServiceCash("");
    //         // setDestinationServiceWallet("");
    //         // setAccountPrefix("");
    //         // setAccountPrefix1("");
    //         // setAccountPrefix2("");
    //         // setRegex("");
    //         // setRegex1("");
    //         // setRegex2("");

    //         _addCorridor();
    //     }
    // };
    const _handleCreate = () => {
        let is_valid = true;

        // Basic input validations
        if (countryName.trim().length === 0) {
            setCountryNameError("Country name is required");
            is_valid = false;
        }
        if (destinationCountry.trim().length === 0) {
            setDestinationCountryError("Country ISO is required");
            is_valid = false;
        }
        if (beneficiaryCurrency.trim().length === 0) {
            setBeneficiaryCurrencyError("Beneficiary currency and decimal precision is required");
            is_valid = false;
        }
        if (paymentType.trim().length === 0) {
            setPaymentTypeError("Payment type is required");
            is_valid = false;
        }
        if (channelBank.trim().length === 0) {
            setChannelBankError("Channel type is required");
            is_valid = false;
        }
        if (destinationService.trim().length === 0) {
            setDestinationServiceError("Destination service tag is required");
            is_valid = false;
        }
        if (accountPrefix.trim().length === 0) {
            setAccountPrefixError("Account URA prefixes is required");
            is_valid = false;
        }

        //---------------------------------
        // JSON + REGEX VALIDATION HELPERS
        //---------------------------------
        const validateJsonAndRegex = (value, setError) => {
            if (!value.trim().length) {
                setError("JSON input is required");
                return false;
            }

            // Step 1: JSON syntax check
            try {
                jsonlint.parse(value);
            } catch (e) {
                setError(`Syntax error: ${e.message}`);
                return false;
            }

            // Step 2: Parse JSON
            let parsed;
            try {
                parsed = JSON.parse(value);
            } catch {
                setError("Invalid JSON object");
                return false;
            }

            // Step 3: Validate regex ONLY if pattern is present
            if (parsed.pattern !== undefined) {
                if (typeof parsed.pattern !== "string") {
                    setError(`"pattern" must be a string`);
                    return false;
                }

                if (parsed.pattern.trim().length > 0) {
                    try {
                        new RegExp(parsed.pattern);
                    } catch (e) {
                        setError(`Invalid regex: ${e.message}`);
                        return false;
                    }
                }
            }

            return true;
        };

        //---------------------------------
        // REGEX 1 (Mandatory)
        //---------------------------------
        setRegexError("");
        const isRegex1Valid = validateJsonAndRegex(regex, setRegexError);
        if (!isRegex1Valid) return;

        //---------------------------------
        // REGEX 2 (Optional)
        //---------------------------------
        setRegex1Error("");
        if (regex1.trim().length > 0) {
            const isRegex2Valid = validateJsonAndRegex(regex1, setRegex1Error);
            if (!isRegex2Valid) return;
        }

        //---------------------------------
        // REGEX 3 (Optional)
        //---------------------------------
        setRegex2Error("");
        if (regex2.trim().length > 0) {
            const isRegex3Valid = validateJsonAndRegex(regex2, setRegex2Error);
            if (!isRegex3Valid) return;
        }

        //---------------------------------
        // SUBMIT
        //---------------------------------
        if (is_valid) {
            _addCorridor();
        }
    };



    //cancel
    const _handleCancel = () => {
        // Clear all inputs
        setCountryName("");
        setPaymentType("");
        setBeneficiaryCurrency("");
        setDestinationCountry("");
        setChannelBank("");
        setDestinationService("");
        setChannelWallet("");
        setDestinationServiceWallet("");
        setChannelCash("");
        setDestinationServiceCash("");

        // Clear errors
        setCountryNameError("");
        setPaymentTypeError("");
        setBeneficiaryCurrencyError("");
        setDestinationCountryError("");
        setChannelBankError("");
        setDestinationServiceError("");
        setAccountPrefixError("");
        setRegexError("");
        setRegex1Error("");
        setRegex2Error("");

        // Close Modal
        _handleCloseModal();
    };

    const _handleCloseModal = () => {
        const closeBtn = document.getElementById("add-corridor-modal-close");
        if (closeBtn) closeBtn.click();
    };


    // API - Add corridor
    const _addCorridor = () => {
        setLoading(true);

        const is_post = true;
        const url = 'corridor_master/add';

        const data = {
            country_name: countryName,
            destination_iso: destinationCountry,
            currency_with_precision: beneficiaryCurrency,
            payment_type: paymentType,

            channel_type_1: channelBank,
            destination_service_tag_1: destinationService,

            channel_type_2: channelCash,
            destination_service_tag_2: destinationServiceCash,

            channel_type_3: channelWallet,
            destination_service_tag_3: destinationServiceWallet,

            uri_prefix_1: accountPrefix,
            regex_1: regex,

            uri_prefix_2: accountPrefix1,
            regex_2: regex1,

            uri_prefix_3: accountPrefix2,
            regex_3: regex2,
        };

        APIService(is_post, url, data).then((response) => {

            if (response.status_code === 200) {

                toast.dismiss();
                toast.success(response.message, {
                    type: "success",
                    className: "e-toast",
                });

                // Close modal on success
                _handleCloseModal();

                // Trigger refresh
                if (typeof onSuccess === "function") {
                    onSuccess();
                }

                // Clear fields ONLY on success
                setBeneficiaryCurrency("");
                setChannelBank("");
                setDestinationCountry("");
                setCountryName("");
                setDestinationService("");
                setPaymentType("");
                setDestinationServiceCash("");
                setChannelCash("");
                setChannelWallet("");
                setDestinationServiceWallet("");

            } else {
                // Do not clear values on error
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error',
                    className: 'e-toast',
                });
            }

            setLoading(false);
        });
    };



    return (
        <div className="modal fade"
            id="add-corridor-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-border-radius-28  mx-auto">
                    <img
                        src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className='d-none'
                        id='add-corridor-modal-close'
                        data-bs-dismiss="modal"
                        alt='close'
                    />

                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">


                        <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
                            Add Corridor
                        </h4>
                        <img src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt='close'
                            className='cursor-pointer'
                            onClick={_handleCloseModal} />

                    </div>

                    <div className="modal-body px-4 pb-2">
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                <BasicFilter
                                    label="Country name"
                                    placeholder="Select country name"
                                    options={countryOptions}
                                    isSearchable={true}
                                    require={true}
                                    error={countryNameError}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onChange={(selectedOption) => {
                                        if (selectedOption) {
                                            setCountryName(selectedOption.value);
                                            setCountryNameError("");
                                            // Auto-populate destination country code (ISO-3)
                                            setDestinationCountry(selectedOption.country_code || "");
                                            setDestinationCountryError("");
                                            // Auto-populate beneficiary currency and decimal precision
                                            setBeneficiaryCurrency(selectedOption.currency_code_with_precision || "");
                                            setBeneficiaryCurrencyError("");
                                        } else {
                                            setCountryName("");
                                            setDestinationCountry("");
                                            setBeneficiaryCurrency("");
                                        }
                                    }}
                                />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Destination country (ISO-3) */}
                                <CustomTextInput label="Destination country (ISO-3)"
                                    placeholder="Destination country (ISO-3)"
                                    type="text"
                                    require
                                    value={destinationCountry}
                                    error={destinationCountryError}
                                    readOnly={true}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setDestinationCountry(e)} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-12 pe-0'>
                                {/* Beneficiary currency and decimal precision */}
                                <CustomTextInput label="Beneficiary currency and decimal precision"
                                    placeholder="Enter beneficiary currency and decimal precision"
                                    type="text"
                                    require
                                    value={beneficiaryCurrency}
                                    error={beneficiaryCurrencyError}
                                    // readOnly={true}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setBeneficiaryCurrency(e)} />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 pe-0 mt-lg-0 mt-md-0 mt-2'>
                                {/* Payment type */}
                                <CustomTextInput label="Payment type"
                                    placeholder="Enter payment type"
                                    type="text"
                                    require
                                    value={paymentType}
                                    error={paymentTypeError}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setPaymentType(e)} />
                            </div>
                        </div>
                        {/* Channel type details */}
                        <h3 className='pt-3 e-primary-font e-font-weight-600 e-font-16 e-text-chinese-black'>Channel type details</h3>
                        <div className='row mt-3'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Channel type */}
                                <CustomTextInput label="1. Channel type"
                                    placeholder="Enter channel type"
                                    type="text"
                                    require
                                    value={channelBank}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    error={channelBankError}
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setChannelBank(e)} />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Channel type */}
                                <CustomTextInput label="Destination service tag"
                                    placeholder="Destination service tag"
                                    type="text"
                                    require
                                    value={destinationService}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    error={destinationServiceError}
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setDestinationService(e)} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Country name */}
                                <CustomTextInput label="Account URA prefixes"
                                    placeholder="Enter account URA prefixes"
                                    type="text"
                                    require
                                    value={accountPrefix}
                                    error={accountPrefixError}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setAccountPrefix(e)} />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                <CustomTextArea placeholder={`Eg:  {
  "pattern": "^[A-Za-z0-9]+$",
  "description": "Allows only alphanumeric characters"
}
`}
                                    label="Regex"
                                    rows={5}
                                    cols={40}
                                    type="text"
                                    require
                                    value={regex}
                                    error={regexError}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    // heightClassName="h-100px"
                                    handleChange={(e) => setRegex(e)}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Channel type */}
                                <CustomTextInput label="2. Channel type"
                                    placeholder="Enter channel type"
                                    type="text"
                                    value={channelCash}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    handleChange={(e) => setChannelCash(e)} />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Channel type */}
                                <CustomTextInput label="Destination service tag"
                                    placeholder="Destination service tag"
                                    type="text"
                                    value={destinationServiceCash}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    handleChange={(e) => setDestinationServiceCash(e)} />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Country name */}
                                <CustomTextInput label="Account URA prefixes"
                                    placeholder="Enter account URA prefixes"
                                    type="text"
                                    // require
                                    value={accountPrefix1}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setAccountPrefix1(e)} />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                <CustomTextArea placeholder={`Eg:  {
  "pattern": "^[A-Za-z0-9]+$",
  "description": "Allows only alphanumeric characters"
}
`}
                                    label="Regex"
                                    rows={5}
                                    cols={40}
                                    type="text"
                                    // require
                                    value={regex1}
                                    error={regex1Error}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    // heightClassName="h-100px"
                                    handleChange={(e) => setRegex1(e)}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Channel type */}
                                <CustomTextInput label="3. Channel type"
                                    placeholder="Enter channel type"
                                    type="text"
                                    value={channelWallet}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    handleChange={(e) => setChannelWallet(e)} />
                            </div>
                            <div className='col-lg-6  col-md-6  col-sm-6 pe-0'>
                                {/* Channel type */}
                                <CustomTextInput label="Destination service tag"
                                    placeholder="Destination service tag"
                                    type="text"
                                    value={destinationServiceWallet}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    handleChange={(e) => setDestinationServiceWallet(e)} />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                {/* Country name */}
                                <CustomTextInput label="Account URA prefixes"
                                    placeholder="Enter account URA prefixes"
                                    type="text"
                                    // require
                                    value={accountPrefix2}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    onKeyPress={_handleCreate}
                                    handleChange={(e) => setAccountPrefix2(e)} />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 pe-0'>
                                <CustomTextArea placeholder={`Eg:  {
  "pattern": "^[A-Za-z0-9]+$",
  "description": "Allows only alphanumeric characters"
}
`}
                                    label="Regex"
                                    rows={5}
                                    cols={40}
                                    type="text"
                                    // require
                                    value={regex2}
                                    error={regex2Error}
                                    // autoFocus={true}
                                    className="w-100"
                                    labelStyle="e-font-weight-400"
                                    // heightClassName="h-100px"
                                    handleChange={(e) => setRegex2(e)}
                                />
                            </div>
                        </div>


                    </div>

                    <div
                        className="modal-footer border-0 p-3"
                        style={{
                            position: "sticky",
                            bottom: 0,
                            background: "#fff",
                            zIndex: 999,
                        }}
                    >
                        <div className='row row-cols-2 w-100 m-0'>
                            <div className='col pe-2'>
                                <SecondaryButton
                                    name="Cancel"
                                    className="w-100"
                                    onPress={_handleCancel}
                                />
                            </div>

                            <div className='col ps-2'>
                                <PrimaryButton
                                    name="Create"
                                    className="w-100 e-bg-primary-blue"
                                    status={loading}
                                    onPress={_handleCreate}
                                />
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};


AddCorridorModal.defaultProps = {
    handleClose: () => { }
}

export default memo(AddCorridorModal);